module.exports = __webpack_public_path__ + "static/media/01_Piano.140e5ff4.mp3";